import { MutationOptions, useMutation, useQuery } from '@tanstack/react-query';
import { FormInstance, FormTemplate } from 'types/step';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export function useFormTemplates(enabled = true) {
  return useQuery<FormTemplate[]>({
    queryKey: [APIKey.FORM_TEMPLATES],
    queryFn: () => baseFetcher(apiRoutes.formTemplates()),
    enabled,
  });
}

export function useFormInstanceMutation(
  id: string,
  options?: Omit<
    MutationOptions<FormInstance, unknown, Partial<FormInstance>>,
    'mutationFn'
  >
) {
  return useMutation<FormInstance, unknown, Partial<FormInstance>>({
    mutationFn: (data) =>
      baseFetcher(apiRoutes.formInstance(id), {
        method: 'PATCH',
        data,
      }),
    ...options,
  });
}
